var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('input',{attrs:{"disabled":_vm.disabled,"type":"file","accept":_vm.accept},on:{"change":_vm.onFileChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }